import { render, staticRenderFns } from "./ChosenCategoryCard.vue?vue&type=template&id=1cc9f317&"
import script from "./ChosenCategoryCard.vue?vue&type=script&lang=js&"
export * from "./ChosenCategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports